// ============================================================
// fondos/efectos/waves.js — «Olas»: ondas senoidales en la franja de ABAJO que se desvanecen hacia
// arriba (efecto de LIENZO)
//
// Rehecho en la F3 del P3 (E5). La versión de siempre apilaba 4 olas rellenas desde el 30 % del alto
// hasta el pie de la sección, cada una al 45 % (claro) o al 85 % (oscuro): tapaba entre el 53 y el
// 70 % de la sección y dejaba el anillo del botón a 1,14. Ahora:
//   · las olas viven en la FRANJA de abajo (`FRANJA` del alto), que en casi todos los bloques es
//     relleno de la sección;
//   · cada una se rellena con un degradado VERTICAL que va de transparente (arriba de la franja) a su
//     alfa (al pie), así que el conjunto se desvanece hacia arriba y no tiene filo;
//   · lo que suman todas al pie es el tope del catálogo (`alfaMax`): cada ola lleva
//     1 − (1 − tope)^(1/n), y ninguna pasa de él.
// Avanza por RELOJ (función de `t`), como siempre: su velocidad no depende de los fps.
//
// MÓDULO PURO: ES2019 sin `?.` ni `??`, sin DOM, sin reloj y sin estado de módulo.
// ============================================================

import { rgbDeBase } from './comun.js';

/** Fracción del alto, desde el pie de la sección, en la que viven las olas. */
export const FRANJA = 0.3;

/** Alfa de cada una de `n` olas para que las `n` sumen `tope` al pie. */
export function alfaPorOla(tope, n) {
    return 1 - Math.pow(1 - tope, 1 / Math.max(1, n));
}

function degradado(s, ctx) {
    const H = s.h;
    const y0 = H - H * FRANJA;
    const g = ctx.createLinearGradient(0, y0, 0, H);
    const rgb = s.rgb;
    g.addColorStop(0, `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0)`);
    g.addColorStop(1, `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${s.alfaOla})`);
    s.degradado = g;
    s.degradadoH = H;
}

export default {
    crear(ctx, e) {
        const p = e.params;
        const speedMult = p.speed != null ? (0.3 + (p.speed - 1) * (2.7 / 9)) : 1.0;
        const n = e.tactil ? 2 : 4;
        const olas = [];
        for (let i = 0; i < n; i++) {
            olas.push({
                // Altura media de la ola dentro de la franja (0 = su borde de arriba, 1 = el pie):
                // la de más atrás, más arriba.
                nivel: 0.25 + 0.55 * (i / Math.max(1, n - 1)),
                // Amplitud, en fracción de la franja: la cresta más alta no sale de ella.
                amplitud: 0.12 + e.azar() * 0.1,
                frecuencia: 1 + e.azar() * 2,
                velocidad: (0.2 + e.azar() * 0.3) * speedMult,
                fase: e.azar() * Math.PI * 2,
            });
        }
        return {
            w: e.w, h: e.h, rgb: rgbDeBase(e.c1), olas: olas,
            alfaOla: alfaPorOla(e.alfa, n),
            degradado: null, degradadoH: 0,
        };
    },

    redimensionar(s, w, h) {
        s.w = w;
        s.h = h;
    },

    dibujar(s, ctx, t) {
        const W = s.w, H = s.h;
        const time = t * 0.001;
        const franja = H * FRANJA;
        const y0 = H - franja;
        // El degradado depende del alto: se rehace solo cuando la sección cambia de alto.
        if (!s.degradado || s.degradadoH !== H) degradado(s, ctx);
        ctx.fillStyle = s.degradado;
        s.olas.forEach(function (ola) {
            ctx.beginPath();
            ctx.moveTo(0, H);
            for (let x = 0; x <= W; x += 10) {
                const nx = x / W;
                const ny = Math.sin(nx * ola.frecuencia * Math.PI * 2 + time * ola.velocidad + ola.fase);
                ctx.lineTo(x, y0 + (ola.nivel + ny * ola.amplitud) * franja);
            }
            ctx.lineTo(W, H);
            ctx.fill();
        });
    },
};
